(() => {
  const DEFAULT_PIXEL_ID = '906895347131750912';
  const PRODUCT_RETURN_KEY = 'mc_product_return_url';
  const BIGO_STORAGE_KEY = '_bge_checkout_bbg';
  const BIGO_EXPLICIT_STORAGE_KEY = '_mc_bigo_explicit_bbg';
  const bbg = firstUrlValue(['bbg', 'my_bbg'], window.location.href, document.referrer).trim();
  const pixelId = firstUrlValue(['pixel_id', 'my_pixel_id'], window.location.href, document.referrer).trim() || DEFAULT_PIXEL_ID;

  if (isValidBbg(bbg)) persistBbg(bbg);
  if (/^\d{6,64}$/.test(pixelId)) writeCookie('_bge_pixel_id', pixelId);
  rememberProductPage();

  function firstUrlValue(names, ...rawUrls) {
    const wanted = new Set(names.map((name) => name.toLowerCase()));
    for (const rawUrl of rawUrls) {
      if (!rawUrl) continue;
      try {
        const url = new URL(rawUrl, window.location.origin);
        for (const [name, value] of url.searchParams.entries()) {
          if (wanted.has(name.toLowerCase()) && value) return safelyDecode(value);
        }
        const hashQuery = url.hash.includes('?') ? url.hash.slice(url.hash.indexOf('?') + 1) : url.hash.replace(/^#/, '');
        for (const [name, value] of new URLSearchParams(hashQuery).entries()) {
          if (wanted.has(name.toLowerCase()) && value) return safelyDecode(value);
        }
      } catch {}
    }
    return '';
  }

  function safelyDecode(value) {
    let result = String(value || '').trim();
    for (let attempt = 0; attempt < 2; attempt += 1) {
      try {
        const decoded = decodeURIComponent(result.replace(/\+/g, ' '));
        if (decoded === result) break;
        result = decoded;
      } catch {
        break;
      }
    }
    return result;
  }

  function isValidBbg(value) {
    return Boolean(value && value.length <= 4096 && !/[\u0000-\u001f\u007f]/.test(value));
  }

  function persistBbg(value) {
    writeCookie('_bge_bbg', value);
    writeCookie('_mc_bigo_explicit_bbg', value);
    try {
      window.localStorage.setItem(BIGO_STORAGE_KEY, value);
      window.localStorage.setItem(BIGO_EXPLICIT_STORAGE_KEY, value);
    } catch {}
  }

  function writeCookie(name, value) {
    const encoded = encodeURIComponent(value);
    try {
      document.cookie = `${name}=${encoded}; Max-Age=7776000; Path=/; Domain=.mercalune.com; Secure; SameSite=Lax`;
      if (!readCookie(name)) document.cookie = `${name}=${encoded}; Max-Age=7776000; Path=/; Secure; SameSite=Lax`;
    } catch {}
  }

  function readCookie(name) {
    const prefix = `${name}=`;
    return document.cookie.split(';').map((part) => part.trim()).find((part) => part.startsWith(prefix)) || '';
  }

  function rememberProductPage() {
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\/?$/i.test(window.location.pathname)) return;
    try {
      const url = new URL(window.location.href);
      url.hash = '';
      window.sessionStorage.setItem(PRODUCT_RETURN_KEY, url.href.slice(0, 2048));
    } catch {}
  }
})();
